module.exports = __webpack_public_path__ + "img/pattern2.f9c9cfb.svg";